import cx from 'classnames';
import React, { useState, useEffect, useMemo, useRef } from 'react';
import {
  Navbar,
  Nav,
  NavItem,
 /* Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Input,
  InputGroup,*/
} from 'reactstrap';
import {  useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getUserData } from '../../utils/getUserInfo';
import { prettifyGroup } from '../../utils/groupDisplay';
import { fetchAllDataApi, getLatestMessages, getUnseenNotifications } from '../../services/notifications';
import { CiLogout } from "react-icons/ci";
import { FaBell, FaSearch, FaBars } from "react-icons/fa"; // header icons
import { seenNotification } from '../../services/notifications';
//import Icon from '../Icon';
import PopoverNotification from './poppupNotification'; // Import the PopoverNotification component

import './Header.css';
import { clearAuthToken } from '../../utils/authUtils';
import { toast } from 'react-toastify';
import { logoutApi } from '../../services/userServicer';
import { goToDccLogin } from '../../utils/dccLogin';
import LanguageSwitcher from '../LanguageSwitcher/LanguageSwitcher';
import { clearAppStorage } from '../../utils/languageStorage';

let BASE_URL_DCC = process.env.REACT_APP_URL_DCC;

export async function loadConfig() {
  // .env is used directly; no encrypted config to load.
}

// Load config on component initialization
loadConfig().then(() => {
});


interface HeaderProps {
  toggleSidebar: () => void;
  className?: string;
}

interface Notification {
  id: number;
  message: string;
  functionsAll: string;
  createdAt: Date;
  seen: boolean;
}

function Header({ toggleSidebar, className }: HeaderProps) {
  const { t } = useTranslation();
  const [dccLink, setDccLink] = useState<any>(BASE_URL_DCC); // State for DCC URL
  //const [isProfileDropdownOpen, setIsProfileDropdownOpen] = useState(false);
//  const [notifications, setNotifications] = useState([]);
 // const [totalCount, setTotalCount] = useState(0);
  const navigate = useNavigate();
  const [isNotiOpen, setIsNotiOpen] = useState(false); // State to control notification popup visibility
  const [unseenCount, setUnseenCount] = useState(0); // Initial dummy data
  const [latestNotification, setlatestNotification] = useState("");
  // Fingerprint of the last fetched payload — skip the setState (and the
  // re-render it triggers) when a fetch comes back with the same data as
  // last time, e.g. on repeat/poll calls that found nothing new.
  const latestNotificationHashRef = useRef<string>("");
  const unseenCountRef = useRef<number>(-1);

  // Signed-in user for the header profile block. Sourced from /auth/me (the
  // same server-verified session ProtectedRoute checks) rather than decoding
  // the local JWT mirror — that mirror is cleared independently of the real
  // session (e.g. by clearing localStorage without logging out), which used
  // to make the header show a generic "User / Member" placeholder even while
  // a real, privileged session was still active — confusing and misleading.
  const [userInfo, setUserInfo] = useState<{ name: string; role: string; initials: string }>({ name: 'User', role: 'Member', initials: 'U' });

  useEffect(() => {
    let cancelled = false;
    const loadUserInfo = () => {
      getUserData().then((user) => {
        if (cancelled) return;
        if (!user) {
          setUserInfo({ name: 'User', role: 'Member', initials: 'U' });
          return;
        }
        const name = user.name || user.username || user.email || 'User';
        const role = user.title || prettifyGroup(user.groupName) || 'Member';
        const initials = String(name).trim().split(/\s+/).map((p: string) => p[0]).slice(0, 2).join('').toUpperCase() || 'U';
        setUserInfo({ name: String(name), role: String(role), initials });
      });
    };
    loadUserInfo();
    window.addEventListener('comply:auth-changed', loadUserInfo);
    return () => {
      cancelled = true;
      window.removeEventListener('comply:auth-changed', loadUserInfo);
    };
  }, []);


  // Dummy data for all notifications
 /* const [allNotification, setAllNotification] = useState<Notification[]>([
    { id: 1, message: 'Notification 1', functionsAll: 'Message', createdAt: new Date(), seen: false },
    { id: 2, message: 'Notification 2', functionsAll: 'Reminder', createdAt: new Date(), seen: true },
    { id: 3, message: 'Notification 3', functionsAll: 'System', createdAt: new Date(), seen: false },
  ]);*/

  // Function to mark notifications as seen
  const seeNotification = async () => {
    try {
      //const userId = localStorage.getItem("userId") || "";
      await seenNotification();
      setUnseenCount(0);
      setIsNotiOpen(false); // Close the notification popup
    } catch (error) {
      //console.error("Error marking notifications as seen:", error);
    }
  };

  // Handle logout
  const handleLogout = async () => {



    try {
      const responseData = await logoutApi();
      if (responseData.success) {

        clearAppStorage();
        clearAuthToken();
        toast("user logged out successfully", { type: "success" });
        goToDccLogin(undefined, { returnTo: false })


      } else {
        clearAppStorage();
    clearAuthToken();
    toast("you logged out but session is still active connect with admin", { type: "error" });
    goToDccLogin(undefined, { returnTo: false })


      }
    } catch (error: any) {

      clearAppStorage();
      clearAuthToken();
      toast("you logged out but session is still active connect with admin", { type: "error" });
      goToDccLogin(undefined, { returnTo: false })
    
    
    }





   
  };

  // Fetch notifications (dummy implementation)
  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        //let userId = localStorage.getItem("userId");
         const latestMessages = await getLatestMessages(`notifications/compliance-notifications-latest`);
        const hash = JSON.stringify(latestMessages?.data ?? null);
        if (hash !== latestNotificationHashRef.current) {
          latestNotificationHashRef.current = hash;
          setlatestNotification(latestMessages?.data)
        }
       // setTotalCount(total_count?.totalCount);
      } catch (error) {
        //console.error("Error fetching data:", error);
      }
    };
    fetchNotifications();
    getUnseenNotificationsData()
  }, []);

  const getUnseenNotificationsData = async () => {
    //const userId = localStorage.getItem("userId") || "";
    const unseenNotifications = await getUnseenNotifications();
    const nextCount = unseenNotifications?.success ? unseenNotifications.totalCount : 0;
    if (nextCount !== unseenCountRef.current) {
      unseenCountRef.current = nextCount;
      setUnseenCount(nextCount);
    }
  };

  // useEffect(() => {
  //   const socket = getWebSocket();

  //   if (socket) {
  //     socket.on('receiveNotification', (notification:any) => {
  //       // Option 1: Increment the unseen count
  //      // //console.log('notification', notification)
  //       setUnseenCount((prevCount) => prevCount + 1);
  //       getUnseenNotificationsData()
  //       // Option 2: Fetch notifications again
  //       // fetchNotifications();
  //     });
  //   }

  //   return () => {
  //     if (socket) {
  //       socket.off('receiveNotification'); // Clean up the event listener
  //     }
  //   };
  // }, []);

  useEffect(() => {
    loadConfig().then(() => {
      setDccLink(BASE_URL_DCC);
    });
  }, []);

  return (
    <Navbar className={`root_header ${className}`} expand="lg">
      {/* Hamburger — collapses/expands the sidebar on desktop, opens the drawer on mobile */}
      <button className="header-hamburger" onClick={toggleSidebar} type="button" aria-label="Toggle menu">
        <FaBars size={18} />
      </button>

      {/* Search */}
      <div className="header-search">
        <FaSearch className="header-search-icon" />
        <input
          type="text"
          placeholder={t('Search ...') || 'Search compliance items, tasks…'}
          className="header-search-input"
        />
      </div>

      {/* Right cluster */}
      <div className="header-actions">
        {/* Language */}
        <LanguageSwitcher variant="light" />

        {/* Notifications */}
        <div className="header-bell-wrap position-relative">
          <button
            className="header-icon-btn"
            type="button"
            onClick={() => setIsNotiOpen((s) => !s)}
            aria-label="Notifications"
          >
            <FaBell size={16} />
            {unseenCount > 0 && <span className="header-bell-dot" />}
          </button>
          <PopoverNotification
            isOpen={isNotiOpen}
            onClose={() => setIsNotiOpen(false)}
            updateNotifications={seeNotification}
            notifications={latestNotification}
          />
        </div>

        <span className="header-divider" />

        {/* User */}
        <div className="header-user" title={`${userInfo.name} — ${userInfo.role}`}>
          <span className="header-user-avatar">{userInfo.initials}</span>
          <span className="header-user-meta">
            <span className="header-user-name">{userInfo.name}</span>
            <span className="header-user-role">{userInfo.role}</span>
          </span>
        </div>

        {/* Logout */}
        <button className="header-logout" onClick={handleLogout} type="button">
          <CiLogout size={18} />
          <span className="d-none d-md-inline">{t('Logout') || 'Logout'}</span>
        </button>
      </div>
    </Navbar>
  );
}

export default Header;